import { render, staticRenderFns } from "./TradingTopNav.vue?vue&type=template&id=120c4bee&scoped=true"
import script from "./TradingTopNav.vue?vue&type=script&lang=js"
export * from "./TradingTopNav.vue?vue&type=script&lang=js"
import style0 from "./TradingTopNav.vue?vue&type=style&index=0&id=120c4bee&prod&scoped=true&lang=css"
import style1 from "./TradingTopNav.vue?vue&type=style&index=1&id=120c4bee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c4bee",
  null
  
)

export default component.exports